const GC = window.__GENERATED_CONSTANTS__

export const AuditActionTypes = GC.AuditActionTypes;
export const AuditEntityTypes = GC.AuditEntityTypes;



// WEBPACK FOOTER //
// ./web/js/panels/auditHsitory/constants.js